export default {
  navigationBarTitleText: intl.get('homePage.homePage'),
  navigationBarBackgroundColor: "#DF773C",
};
